export default __webpack_public_path__ + "static/apple-icon-144x144-f93652adf83f510a4a5208aae600f3f2.png";